export default "__VITE_ASSET__DNR5d8DW__"